var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticStyle: { margin: "0 20px", height: "calc(100% - 55px)" } },
    [
      _c("div", [
        _c("div", { staticClass: "list_header" }, [
          _c(
            "div",
            { staticStyle: { display: "flex", "align-items": "center" } },
            [
              _c("i", {
                staticClass: "el-icon-arrow-left go_icon",
                staticStyle: { cursor: "pointer" },
                on: { click: _vm.checkdetail1 },
              }),
              _c(
                "div",
                {
                  staticClass: "list_header_",
                  staticStyle: { "margin-left": "24px" },
                },
                [
                  _c("span", { staticClass: "list_heade_line" }, [
                    _vm._v("考核周期: "),
                  ]),
                  _c(
                    "span",
                    { staticStyle: { "font-size": "16px", color: "#333" } },
                    [_vm._v(_vm._s(_vm.detailInfos.meritsDate))]
                  ),
                ]
              ),
              _vm.detailInfos.realityScore
                ? _c("div", { staticClass: "list_header_" }, [
                    _c("span", { staticClass: "list_heade_line" }, [
                      _vm._v("综合得分: "),
                    ]),
                    _vm.detailInfos.realityScore
                      ? _c(
                          "span",
                          {
                            staticStyle: {
                              "font-size": "16px",
                              color: "#ff0000",
                            },
                          },
                          [_vm._v(_vm._s(_vm.detailInfos.realityScore))]
                        )
                      : _c("span", [_vm._v("-")]),
                    _vm.type !== "tome"
                      ? _c("span", [
                          _vm.type === "examine"
                            ? _c(
                                "span",
                                [
                                  _vm.dialogModifiedScore.scoreTableData &&
                                  _vm.dialogModifiedScore.scoreTableData
                                    .length > 0
                                    ? _c(
                                        "span",
                                        [
                                          _c(
                                            "el-tooltip",
                                            {
                                              staticClass: "item",
                                              attrs: {
                                                effect: "dark",
                                                content: "总分调整",
                                                placement: "bottom",
                                              },
                                            },
                                            [
                                              _c("i", {
                                                staticClass:
                                                  "iconfont icon-chaoshishoujiatiaozheng",
                                                staticStyle: {
                                                  "padding-left": "10px",
                                                  color: "#2878ff",
                                                },
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.changeScore(
                                                      _vm.detailInfos
                                                    )
                                                  },
                                                },
                                              }),
                                            ]
                                          ),
                                        ],
                                        1
                                      )
                                    : _c(
                                        "el-tooltip",
                                        {
                                          staticClass: "item",
                                          attrs: {
                                            effect: "dark",
                                            content: "总分调整",
                                            placement: "bottom",
                                          },
                                        },
                                        [
                                          _c("i", {
                                            staticClass:
                                              "iconfont icon-chaoshishoujiatiaozheng",
                                            staticStyle: {
                                              "padding-left": "10px",
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.changeScore(
                                                  _vm.detailInfos
                                                )
                                              },
                                            },
                                          }),
                                        ]
                                      ),
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm.type === "me" || _vm.type === "fromme "
                            ? _c(
                                "span",
                                [
                                  _vm.dialogModifiedScore.scoreTableData &&
                                  _vm.dialogModifiedScore.scoreTableData
                                    .length > 0
                                    ? _c(
                                        "el-tooltip",
                                        {
                                          staticClass: "item",
                                          attrs: {
                                            effect: "dark",
                                            content: "总分调整",
                                            placement: "bottom",
                                          },
                                        },
                                        [
                                          _c("i", {
                                            staticClass:
                                              "iconfont icon-chaoshishoujiatiaozheng",
                                            staticStyle: {
                                              "padding-left": "10px",
                                              color: "#2878ff",
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.changeScore(
                                                  _vm.detailInfos
                                                )
                                              },
                                            },
                                          }),
                                        ]
                                      )
                                    : _vm._e(),
                                ],
                                1
                              )
                            : _vm._e(),
                        ])
                      : _vm._e(),
                  ])
                : _vm._e(),
              _vm.detailInfos.gradeName
                ? _c(
                    "div",
                    {
                      staticClass: "list_header_",
                      staticStyle: {
                        padding: "5px 12px",
                        "border-radius": "4px",
                      },
                    },
                    [
                      _c("span", { staticClass: "list_heade_line" }, [
                        _vm._v("评分等级: "),
                      ]),
                      _c("span", { staticStyle: { "font-size": "16px" } }, [
                        _c(
                          "span",
                          {
                            staticStyle: { "padding-right": "5px" },
                            style: "color: " + _vm.detailInfos.gradeColor,
                          },
                          [_vm._v(_vm._s(_vm.detailInfos.gradeName))]
                        ),
                        _vm.detailInfos.gradeRemark
                          ? _c("span", { staticStyle: { color: "#999999" } }, [
                              _vm._v(
                                "(" + _vm._s(_vm.detailInfos.gradeRemark) + ")"
                              ),
                            ])
                          : _vm._e(),
                      ]),
                    ]
                  )
                : _vm._e(),
              _vm.detailInfos.meritsUserModel
                ? _c("div", { staticClass: "list_header_" }, [
                    _c("span", { staticClass: "list_heade_line" }, [
                      _vm._v("考核人: "),
                    ]),
                    _vm.channel === "ding"
                      ? _c("span", { staticStyle: { "font-size": "15px" } }, [
                          _vm._v(_vm._s(_vm.detailInfos.meritsUserModel.name)),
                        ])
                      : _vm._e(),
                    _vm.channel === "wechat"
                      ? _c(
                          "span",
                          { staticStyle: { "font-size": "15px" } },
                          [
                            _c("ww-open-data", {
                              attrs: {
                                type: "userName",
                                openid: _vm.detailInfos.meritsUserModel.name,
                              },
                            }),
                          ],
                          1
                        )
                      : _vm._e(),
                  ])
                : _vm._e(),
            ]
          ),
          _c(
            "div",
            [
              _c(
                "el-button",
                { attrs: { plain: "" }, on: { click: _vm.exportMeri } },
                [_c("span", [_vm._v("导出明细")])]
              ),
              _vm.detailInfos.submitFlag
                ? _c(
                    "el-button",
                    {
                      attrs: { plain: "", type: "primary" },
                      on: {
                        click: function ($event) {
                          $event.stopPropagation()
                          return _vm.submitInfo.apply(null, arguments)
                        },
                      },
                    },
                    [_c("span", [_vm._v("提交")])]
                  )
                : _vm._e(),
            ],
            1
          ),
        ]),
        _c(
          "div",
          { staticStyle: { height: "96%" } },
          [
            _c("w-loading", {
              ref: "loading",
              attrs: { text: "加载中..", mask: true, click: true },
            }),
            _c(
              "div",
              {
                staticClass: "table-box",
                staticStyle: { height: "calc(100vh - 250px)" },
              },
              [
                _c(
                  "el-table",
                  {
                    ref: "table",
                    staticStyle: { width: "100%" },
                    attrs: {
                      data: _vm.tableData,
                      "header-cell-style": {
                        background: "#F1F1F1 ",
                        fontSize: "14px",
                        color: "#999999",
                      },
                      "span-method": _vm.objectSpanMethod,
                      "cell-class-name": _vm.getCellClassName,
                      border: "",
                      "cell-style": {
                        fontSize: "14px",
                      },
                      height: "100%",
                    },
                  },
                  [
                    _c("el-table-column", {
                      attrs: {
                        fixed: "",
                        prop: "typeName",
                        label: "考核分类",
                        width: "100",
                        "text-align": "center",
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c(
                                "div",
                                {
                                  staticStyle: {
                                    width: "100%",
                                    "text-align": "center",
                                  },
                                },
                                [_vm._v(_vm._s(scope.row.typeName))]
                              ),
                              _c(
                                "div",
                                {
                                  staticStyle: {
                                    width: "100%",
                                    "text-align": "center",
                                  },
                                },
                                [_vm._v(_vm._s(scope.row.typeScore) + "%")]
                              ),
                            ]
                          },
                        },
                      ]),
                    }),
                    _c("el-table-column", {
                      attrs: {
                        fixed: "",
                        prop: "content",
                        label: "考核内容",
                        "min-width": "200",
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c("div", [_vm._v(_vm._s(scope.row.content))]),
                            ]
                          },
                        },
                      ]),
                    }),
                    _c("el-table-column", {
                      attrs: { prop: "score", label: "分值", width: "60" },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              scope.row.type === "0"
                                ? _c("div", [
                                    _vm._v(
                                      " " +
                                        _vm._s(scope.row.taskNormalScore) +
                                        " "
                                    ),
                                  ])
                                : _c("div", [_vm._v(_vm._s(scope.row.score))]),
                            ]
                          },
                        },
                      ]),
                    }),
                    _vm._l(_vm.tableHeaders, function (header, index) {
                      return _c("el-table-column", {
                        key: index,
                        attrs: { prop: header.prop, "min-width": "200" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "header",
                              fn: function () {
                                return [
                                  _c(
                                    "span",
                                    {
                                      domProps: {
                                        innerHTML: _vm._s(header.label),
                                      },
                                    },
                                    [_vm._v(_vm._s(header.label))]
                                  ),
                                ]
                              },
                              proxy: true,
                            },
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  scope.row.extendValue[header.prop] ||
                                  scope.row.extendValue[header.prop] === 0
                                    ? _c("div", {
                                        domProps: {
                                          innerHTML: _vm._s(
                                            _vm.getFormattedValue(
                                              scope.row.extendValue[header.prop]
                                            )
                                          ),
                                        },
                                      })
                                    : _vm._e(),
                                  scope.row.extendValue[
                                    header.prop + "_file"
                                  ] &&
                                  scope.row.extendValue[header.prop + "_file"]
                                    .length > 0
                                    ? _c(
                                        "div",
                                        _vm._l(
                                          scope.row.extendValue[
                                            header.prop + "_file"
                                          ],
                                          function (item, index1) {
                                            return _c(
                                              "div",
                                              {
                                                key: index1,
                                                staticStyle: {
                                                  padding: "5px 0",
                                                  cursor: "pointer",
                                                  display: "flex",
                                                  "align-items": "center",
                                                },
                                                on: {
                                                  click: function ($event) {
                                                    $event.stopPropagation()
                                                    return _vm.previewFile(item)
                                                  },
                                                },
                                              },
                                              [
                                                _c("i", {
                                                  staticClass:
                                                    "iconfont icon-wenjian file__icon",
                                                }),
                                                _c(
                                                  "el-tooltip",
                                                  {
                                                    attrs: {
                                                      effect: "dark",
                                                      content: item.fileName,
                                                      placement: "bottom",
                                                      "popper-class":
                                                        "texttooltip",
                                                      "open-delay": 500,
                                                    },
                                                  },
                                                  [
                                                    _c(
                                                      "span",
                                                      {
                                                        staticStyle: {
                                                          overflow: "hidden",
                                                          "text-overflow":
                                                            "ellipsis",
                                                          "white-space":
                                                            "nowrap",
                                                          "max-width": "140px",
                                                          display:
                                                            "inline-block",
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(item.fileName)
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                ),
                                              ],
                                              1
                                            )
                                          }
                                        ),
                                        0
                                      )
                                    : _vm._e(),
                                ]
                              },
                            },
                          ],
                          null,
                          true
                        ),
                      })
                    }),
                    _vm.detailInfos.submitFlag && _vm.detailInfos.status !== "1"
                      ? _c("el-table-column", {
                          attrs: {
                            fixed: "right",
                            prop: "score",
                            label: _vm.getScoreTypeLabel(_vm.detailInfos),
                            width: "100",
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    scope.row.extendEdit &&
                                    !scope.row.extendEdit.editFlag
                                      ? _c("div", [
                                          scope.row.type === "0" &&
                                          scope.row.extendEdit.type == "0"
                                            ? _c("span", [
                                                _vm._v(
                                                  _vm._s(
                                                    scope.row.extendEdit
                                                      .flowScore
                                                  )
                                                ),
                                              ])
                                            : _c("span", [
                                                _vm._v(
                                                  _vm._s(
                                                    scope.row.extendEdit
                                                      .flowScore
                                                  )
                                                ),
                                              ]),
                                        ])
                                      : _c("div", [
                                          scope.row.type === "0" &&
                                          scope.row.extendEdit.type == "0"
                                            ? _c(
                                                "div",
                                                [
                                                  _c("el-input", {
                                                    staticStyle: {
                                                      width: "100%",
                                                      height: "110px",
                                                    },
                                                    attrs: {
                                                      type: "text",
                                                      min: "0",
                                                      max: "200",
                                                      placeholder:
                                                        _vm.getScoreTypePlaceholder(
                                                          _vm.detailInfos
                                                        ),
                                                    },
                                                    on: {
                                                      input: function ($event) {
                                                        return _vm.handleInput1(
                                                          $event,
                                                          scope.row
                                                        )
                                                      },
                                                      blur: function ($event) {
                                                        return _vm.changeText(
                                                          scope.row,
                                                          scope.$index
                                                        )
                                                      },
                                                    },
                                                    model: {
                                                      value:
                                                        scope.row.extendEdit
                                                          .flowScore,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          scope.row.extendEdit,
                                                          "flowScore",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "scope.row.extendEdit.flowScore",
                                                    },
                                                  }),
                                                ],
                                                1
                                              )
                                            : _c(
                                                "div",
                                                [
                                                  _c("el-input", {
                                                    staticStyle: {
                                                      width: "100%",
                                                      height: "110px",
                                                    },
                                                    attrs: {
                                                      type: "text",
                                                      min: "0",
                                                      max: "200",
                                                      placeholder:
                                                        _vm.getScoreTypePlaceholder(
                                                          _vm.detailInfos
                                                        ),
                                                    },
                                                    on: {
                                                      input: function ($event) {
                                                        return _vm.handleInput2(
                                                          $event,
                                                          scope.row
                                                        )
                                                      },
                                                      blur: function ($event) {
                                                        return _vm.changeText(
                                                          scope.row,
                                                          scope.$index
                                                        )
                                                      },
                                                    },
                                                    model: {
                                                      value:
                                                        scope.row.extendEdit
                                                          .flowScore,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          scope.row.extendEdit,
                                                          "flowScore",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "scope.row.extendEdit.flowScore",
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                        ]),
                                  ]
                                },
                              },
                            ],
                            null,
                            false,
                            2568362816
                          ),
                        })
                      : _vm._e(),
                    _vm.detailInfos.submitFlag && _vm.detailInfos.status !== "1"
                      ? _c("el-table-column", {
                          attrs: {
                            fixed: "right",
                            prop: "scoreRemark",
                            label: "评分说明",
                            width: "200",
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    scope.row.extendEdit &&
                                    !scope.row.extendEdit.editFlag
                                      ? _c("div", [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                scope.row.extendEdit.remark
                                              ) +
                                              " "
                                          ),
                                        ])
                                      : _c(
                                          "div",
                                          {
                                            staticClass: "describe",
                                            on: {
                                              click: function ($event) {
                                                return _vm.handleFocus(
                                                  scope.row,
                                                  scope.$index
                                                )
                                              },
                                            },
                                          },
                                          [
                                            _c("el-input", {
                                              staticStyle: { width: "100%" },
                                              style: {
                                                height: _vm.getInputHeight(
                                                  scope.row.extendEdit.fileList
                                                    .length
                                                ),
                                              },
                                              attrs: {
                                                type: "textarea",
                                                maxlength: "2000",
                                                placeholder: "请输入",
                                              },
                                              on: {
                                                blur: function ($event) {
                                                  return _vm.changeText(
                                                    scope.row,
                                                    scope.$index
                                                  )
                                                },
                                                focus: function ($event) {
                                                  return _vm.handleFocus(
                                                    scope.row,
                                                    scope.$index
                                                  )
                                                },
                                              },
                                              model: {
                                                value:
                                                  scope.row.extendEdit.remark,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    scope.row.extendEdit,
                                                    "remark",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "scope.row.extendEdit.remark",
                                              },
                                            }),
                                            _c(
                                              "div",
                                              {
                                                staticClass: "file_lists",
                                                style: {
                                                  height: _vm.getListtHeight(
                                                    scope.row.extendEdit
                                                      .fileList.length
                                                  ),
                                                },
                                              },
                                              _vm._l(
                                                scope.row.extendEdit.fileList,
                                                function (item, index) {
                                                  return _c(
                                                    "div",
                                                    {
                                                      key: index,
                                                      staticClass: "file_boxs",
                                                    },
                                                    [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "file_text",
                                                          staticStyle: {
                                                            width: "100%",
                                                            display: "flex",
                                                            "align-items":
                                                              "center",
                                                          },
                                                          on: {
                                                            click: function (
                                                              $event
                                                            ) {
                                                              $event.stopPropagation()
                                                              return _vm.previewFile(
                                                                item,
                                                                index
                                                              )
                                                            },
                                                          },
                                                        },
                                                        [
                                                          _c("i", {
                                                            staticClass:
                                                              "iconfont icon-wenjian file__icon",
                                                          }),
                                                          _c(
                                                            "el-tooltip",
                                                            {
                                                              attrs: {
                                                                effect: "dark",
                                                                content:
                                                                  item.fileName,
                                                                placement:
                                                                  "bottom",
                                                                "popper-class":
                                                                  "texttooltip",
                                                                "open-delay": 500,
                                                              },
                                                            },
                                                            [
                                                              _c(
                                                                "span",
                                                                {
                                                                  staticStyle: {
                                                                    overflow:
                                                                      "hidden",
                                                                    "text-overflow":
                                                                      "ellipsis",
                                                                    "white-space":
                                                                      "nowrap",
                                                                    "max-width":
                                                                      "110px",
                                                                    display:
                                                                      "inline-block",
                                                                  },
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      item.fileName
                                                                    )
                                                                  ),
                                                                ]
                                                              ),
                                                            ]
                                                          ),
                                                        ],
                                                        1
                                                      ),
                                                      _c("span", [
                                                        _c("i", {
                                                          staticClass:
                                                            "iconfont icon-shanchu1 del__icon",
                                                          on: {
                                                            click: function (
                                                              $event
                                                            ) {
                                                              $event.stopPropagation()
                                                              return _vm.delFun(
                                                                item,
                                                                index,
                                                                scope.$index
                                                              )
                                                            },
                                                          },
                                                        }),
                                                      ]),
                                                    ]
                                                  )
                                                }
                                              ),
                                              0
                                            ),
                                            _vm.uploadType === "ding"
                                              ? _c(
                                                  "div",
                                                  {
                                                    staticClass: "upload",
                                                    on: {
                                                      click: _vm.uploadFile,
                                                    },
                                                  },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "uploadfile",
                                                      },
                                                      [
                                                        _c("i", {
                                                          staticClass:
                                                            "iconfont icon-shangchuan file_icon",
                                                        }),
                                                      ]
                                                    ),
                                                  ]
                                                )
                                              : _vm._e(),
                                            _vm.uploadType === "oss"
                                              ? _c(
                                                  "div",
                                                  { staticClass: "upload" },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "uploadfile",
                                                      },
                                                      [
                                                        _c("multi-upload", {
                                                          attrs: {
                                                            "file-data":
                                                              _vm.fileData,
                                                            "upload-btn":
                                                              _vm.uploadBtn,
                                                          },
                                                          on: {
                                                            setFileList:
                                                              _vm.successFile,
                                                          },
                                                        }),
                                                      ],
                                                      1
                                                    ),
                                                  ]
                                                )
                                              : _vm._e(),
                                          ],
                                          1
                                        ),
                                  ]
                                },
                              },
                            ],
                            null,
                            false,
                            1030741981
                          ),
                        })
                      : _vm._e(),
                    _vm.detailInfos.status === "1"
                      ? _c("el-table-column", {
                          attrs: {
                            fixed: "right",
                            prop: "score",
                            label: "考核分",
                            width: "100",
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "header",
                                fn: function () {
                                  return [
                                    _vm._v(" 考核分 "),
                                    _c(
                                      "el-tooltip",
                                      {
                                        staticClass: "item",
                                        attrs: {
                                          effect: "dark",
                                          content:
                                            "(分类得分项合计 * 评分占比 / 分类分值总计) * 分类占比 = 分类考核分",
                                          placement: "bottom",
                                        },
                                      },
                                      [
                                        _c("i", {
                                          staticClass:
                                            "iconfont icon-shuoming progress_icon",
                                        }),
                                      ]
                                    ),
                                  ]
                                },
                                proxy: true,
                              },
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _c("div", [
                                      _c("span", [
                                        _vm._v(
                                          _vm._s(scope.row.totalTypeScore)
                                        ),
                                      ]),
                                    ]),
                                  ]
                                },
                              },
                            ],
                            null,
                            false,
                            1814237885
                          ),
                        })
                      : _vm._e(),
                  ],
                  2
                ),
              ],
              1
            ),
          ],
          1
        ),
      ]),
      _c("Dialogs", {
        attrs: { dialogs: _vm.dialogModifiedScore },
        on: { dialogVisible: _vm.beforeClose },
        scopedSlots: _vm._u([
          {
            key: "desc",
            fn: function () {
              return [
                _vm.dialogModifiedScore.scoreTableData &&
                _vm.dialogModifiedScore.scoreTableData.length > 0
                  ? _c(
                      "div",
                      {
                        staticClass: "info_subject",
                        staticStyle: {
                          height: "calc(100vh - 630px)",
                          overflow: "auto",
                        },
                      },
                      [
                        _c(
                          "el-table",
                          {
                            staticClass: "append_table",
                            staticStyle: { height: "100%", overflow: "auto" },
                            attrs: {
                              data: _vm.dialogModifiedScore.scoreTableData,
                              "header-cell-style": {
                                background: "#F1F1F1 ",
                                fontSize: "14px",
                                color: "#999999",
                              },
                              border: "",
                            },
                          },
                          [
                            _c("el-table-column", {
                              attrs: { prop: "type", label: "类型" },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function (scope) {
                                      return [
                                        !scope.row.id
                                          ? _c(
                                              "div",
                                              { staticClass: "score_input" },
                                              [
                                                _c(
                                                  "el-select",
                                                  {
                                                    ref: "input_authType",
                                                    staticStyle: {
                                                      width: "80px",
                                                    },
                                                    attrs: {
                                                      placeholder: "查看权限",
                                                    },
                                                    on: {
                                                      change: function (
                                                        $event
                                                      ) {
                                                        return _vm.blurChange(
                                                          scope.row
                                                        )
                                                      },
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.scoreValue.type,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          _vm.scoreValue,
                                                          "type",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "scoreValue.type",
                                                    },
                                                  },
                                                  _vm._l(
                                                    _vm.scoreValue.scoreType,
                                                    function (item) {
                                                      return _c("el-option", {
                                                        key: item.id,
                                                        attrs: {
                                                          label: item.name,
                                                          value: item.id,
                                                        },
                                                      })
                                                    }
                                                  ),
                                                  1
                                                ),
                                              ],
                                              1
                                            )
                                          : _c("div", [
                                              scope.row.type === "+"
                                                ? _c("div", [_vm._v("加分")])
                                                : _vm._e(),
                                              scope.row.type === "-"
                                                ? _c("div", [_vm._v("减分")])
                                                : _vm._e(),
                                            ]),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                false,
                                3948408303
                              ),
                            }),
                            _c("el-table-column", {
                              attrs: { prop: "score", label: "分值" },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function (scope) {
                                      return [
                                        !scope.row.id
                                          ? _c(
                                              "div",
                                              { staticClass: "score_input" },
                                              [
                                                _c("el-input", {
                                                  attrs: {
                                                    placeholder: "请输入分值",
                                                    type: "Number",
                                                  },
                                                  model: {
                                                    value: _vm.scoreValue.num,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        _vm.scoreValue,
                                                        "num",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "scoreValue.num",
                                                  },
                                                }),
                                              ],
                                              1
                                            )
                                          : _c("div", [
                                              _vm._v(_vm._s(scope.row.score)),
                                            ]),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                false,
                                2224599250
                              ),
                            }),
                            _c("el-table-column", {
                              attrs: { prop: "desc", label: "说明" },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function (scope) {
                                      return [
                                        !scope.row.id
                                          ? _c(
                                              "div",
                                              { staticClass: "score_input" },
                                              [
                                                _c("el-input", {
                                                  attrs: {
                                                    placeholder: "请输入说明",
                                                    type: "textarea",
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.scoreValue.content,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        _vm.scoreValue,
                                                        "content",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "scoreValue.content",
                                                  },
                                                }),
                                              ],
                                              1
                                            )
                                          : _c("div", [
                                              _vm._v(_vm._s(scope.row.content)),
                                            ]),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                false,
                                2147893573
                              ),
                            }),
                            _c("el-table-column", {
                              attrs: { prop: "createByUser", label: "操作人" },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function (scope) {
                                      return [
                                        _vm.channel === "wechat"
                                          ? _c(
                                              "div",
                                              [
                                                _c("ww-open-data", {
                                                  attrs: {
                                                    type: "userName",
                                                    openid:
                                                      scope.row.createByUser
                                                        .name,
                                                  },
                                                }),
                                              ],
                                              1
                                            )
                                          : _c("div", [
                                              _vm._v(
                                                _vm._s(
                                                  scope.row.createByUser.name
                                                )
                                              ),
                                            ]),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                false,
                                3610861442
                              ),
                            }),
                            _c("el-table-column", {
                              attrs: {
                                prop: "createDate",
                                label: "操作时间",
                                width: "180",
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function (scope) {
                                      return [
                                        _c("div", [
                                          _vm._v(
                                            _vm._s(
                                              scope.row.createDate.substring(
                                                0,
                                                10
                                              )
                                            )
                                          ),
                                        ]),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                false,
                                2749759394
                              ),
                            }),
                            _c("el-table-column", {
                              attrs: { prop: "dele", label: "操作" },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function (scope) {
                                      return [
                                        !scope.row.id
                                          ? _c(
                                              "div",
                                              {
                                                staticStyle: {
                                                  "text-align": "center",
                                                },
                                              },
                                              [
                                                _c(
                                                  "el-button",
                                                  {
                                                    attrs: { size: "mini" },
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.handleEdit(
                                                          scope.$index
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [_vm._v("取消")]
                                                ),
                                                _c(
                                                  "el-button",
                                                  {
                                                    attrs: {
                                                      size: "mini",
                                                      type: "primary",
                                                    },
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.addScore(
                                                          scope.$index
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [_vm._v("确定")]
                                                ),
                                              ],
                                              1
                                            )
                                          : _vm._e(),
                                        scope.row.id
                                          ? _c(
                                              "el-tooltip",
                                              {
                                                attrs: {
                                                  effect: "dark",
                                                  content: "删除",
                                                  placement: "top",
                                                  "popper-class": "texttooltip",
                                                },
                                              },
                                              [
                                                _c("i", {
                                                  staticClass:
                                                    "iconfont icon-shanchu1 icon_btn",
                                                  staticStyle: {
                                                    cursor: "pointer",
                                                  },
                                                  on: {
                                                    click: function ($event) {
                                                      $event.stopPropagation()
                                                      return _vm.delScore(
                                                        scope.$index,
                                                        scope.row
                                                      )
                                                    },
                                                  },
                                                }),
                                              ]
                                            )
                                          : _vm._e(),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                false,
                                3735533254
                              ),
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    )
                  : _c(
                      "div",
                      {
                        staticClass: "info_subject",
                        staticStyle: {
                          "align-items": "center",
                          "justify-content": "center",
                        },
                      },
                      [
                        _c("el-empty", {
                          attrs: {
                            image:
                              "https://scpcm.oss-cn-hangzhou.aliyuncs.com/static/pc/stateImg/nodata_pc.png",
                            "image-size": 223,
                            description: "暂无数据",
                          },
                        }),
                      ],
                      1
                    ),
              ]
            },
            proxy: true,
          },
        ]),
      }),
      _c("VideoPreview", {
        attrs: { visible: _vm.showVideo, url: _vm.videoUrl },
        on: {
          "update:visible": [
            function ($event) {
              _vm.showVideo = $event
            },
            function (val) {
              return _vm.console.log("visible 更新为:", val)
            },
          ],
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }